// src/Components/NavveerFoundationLibrary.jsx
import React, { useEffect, useState } from "react";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";

export default function NavveerFoundationLibrary() {
  const [books, setBooks] = useState([]);
  const [search, setSearch] = useState("");

  // ----- Styles (inline objects so no separate CSS file needed) -----
  const containerStyle = {
    padding: "40px 20px",
    maxWidth: 1300,
    margin: "0 auto",
  };

  const headingStyle = {
    fontSize: 26,
    marginBottom: 20,
    color: "#333",
    textAlign: "left",
  };

  const searchInputStyle = {
    padding: "10px 15px",
    width: "100%",
    maxWidth: 420,
    border: "1px solid #ccc",
    borderRadius: 8,
    marginBottom: 30,
    fontSize: 15,
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))",
    gap: 26,
  };

  const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: 10,
    boxShadow: "0 3px 12px rgba(0, 0, 0, 0.08)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  };

  const coverWrapperStyle = {
    position: "relative",
    width: "100%",
    height: 240,
    background: "#f5f5f5",
    overflow: "hidden",
  };

  const coverImgStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  };

  const infoStyle = {
    padding: "10px 12px 14px",
  };

  const titleStyle = {
    fontSize: 16,
    margin: "4px 0 4px",
    color: "#222",
    fontWeight: 600,
    lineHeight: 1.3,
  };

  const authorStyle = {
    fontSize: 13,
    color: "#666",
    marginBottom: 10,
  };

  const viewBtnStyle = {
    padding: "6px 12px",
    borderRadius: 6,
    border: "none",
    backgroundColor: "#1976d2",
    color: "#fff",
    fontSize: 14,
    cursor: "pointer",
  };

  // ------------------------------------------------------------------

  // Load from Firestore (foundationBooks)
  useEffect(() => {
    const q = query(
      collection(db, "foundationBooks"),
      orderBy("createdAt", "desc")
    );

    const unsub = onSnapshot(
      q,
      (snapshot) => {
        const items = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setBooks(items);
      },
      (err) => {
        console.error("Failed to load foundation books:", err);
      }
    );

    return () => unsub();
  }, []);

  // Fast UX: listen for "foundationBookUploaded" event from Admin.jsx
  useEffect(() => {
    const onFoundationBookUploaded = (e) => {
      const newBook = e.detail;
      if (!newBook) return;

      setBooks((prev) => {
        if (prev.some((b) => b.id === newBook.id)) return prev;
        return [{ ...newBook }, ...prev];
      });
    };

    window.addEventListener(
      "foundationBookUploaded",
      onFoundationBookUploaded
    );
    return () =>
      window.removeEventListener(
        "foundationBookUploaded",
        onFoundationBookUploaded
      );
  }, []);

  // Filter by search (title or author)
  const filteredBooks = books.filter((b) => {
    const q = search.toLowerCase();
    return (
      (b.title || "").toLowerCase().includes(q) ||
      (b.author || "").toLowerCase().includes(q)
    );
  });

  const handleView = (book) => {
    if (!book?.pdfUrl) return;
    window.open(book.pdfUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div style={containerStyle}>
      <h2 style={headingStyle}>📘 Navveer Foundation Library</h2>

      {/* Search bar */}
      <input
        type="text"
        placeholder="Search by title or author..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={searchInputStyle}
      />

      {/* Books list */}
      {filteredBooks.length ? (
        <div style={gridStyle}>
          {filteredBooks.map((book) => (
            <div key={book.id} style={cardStyle}>
              {/* Cover */}
              <div style={coverWrapperStyle}>
                <img
                  src={book.coverUrl || "/logo.png"}
                  alt={book.title}
                  style={coverImgStyle}
                />
              </div>

              {/* Info */}
              <div style={infoStyle}>
                <h3 style={titleStyle}>{book.title}</h3>
                <p style={authorStyle}>
                  {book.author ? `by ${book.author}` : "Navveer Foundation"}
                </p>

                {/* Only View button */}
                {book.pdfUrl && (
                  <button
                    style={viewBtnStyle}
                    onClick={() => handleView(book)}
                  >
                    View
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No Navveer Foundation books found.</p>
      )}
    </div>
  );
}



//course